import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectGeoRegion = createSelector([selectPartner360Data], ({ geoRegion }) => geoRegion)
